module.exports = __webpack_public_path__ + "static/img/cooperation13.8c68da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/cooperation13.png
// module id = yAOg
// module chunks = 0